import { render, staticRenderFns } from "./NpsScore.vue?vue&type=template&id=73b5c5f3&scoped=true&lang=pug"
import script from "./NpsScore.vue?vue&type=script&lang=ts"
export * from "./NpsScore.vue?vue&type=script&lang=ts"
import style0 from "./NpsScore.vue?vue&type=style&index=0&id=73b5c5f3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5c5f3",
  null
  
)

/* custom blocks */
import block0 from "./NpsScore.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FNpsScore%2FNpsScore.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports